// Mock data for The Wisdom Network website

export const navigationItems = [
  { name: "HOME", href: "/" },
  { name: "BOOK NOW", href: "https://twnhub.online/services" },
  { name: "PRACTITIONERS", href: "/practitioners" },
  { name: "EXPERIENCES", href: "/experiences" },
  { name: "REVIEWS", href: "/reviews" },
  { name: "MEMBERSHIP", href: "/membership" },
  { name: "COMMUNITY", href: "/membership" },
  { name: "HOW IT WORKS", href: "/how-it-works" },
  { name: "ABOUT US", href: "/about" },
  { name: "FAQ", href: "/faq" }
];

export const practitioners = [
  {
    id: 1,
    name: "Audrina Manciel",
    title: "VISIONARY",
    image: "https://images.unsplash.com/photo-1500904156668-758cff89dcff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxzcGlyaXR1YWwlMjBoZWFsaW5nfGVufDB8fHx8MTc1NTg4NzM2NXww&ixlib=rb-4.1.0&q=85",
    description: "Intuitive healer specializing in soul awakening and spiritual transformation."
  },
  {
    id: 2,
    name: "Charity Moran",
    title: "CATALYST",
    image: "https://images.unsplash.com/photo-1483691278019-cb7253bee49f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxzcGlyaXR1YWwlMjBoZWFsaW5nfGVufDB8fHx8MTc1NTg4NzM2NXww&ixlib=rb-4.1.0&q=85",
    description: "Energy catalyst focusing on breakthrough healing and personal empowerment."
  },
  {
    id: 3,
    name: "Dannielle Holmes",
    title: "NURTURER",
    image: "https://images.unsplash.com/photo-1603166868295-4ae2cba14063?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxzcGlyaXR1YWwlMjBoZWFsaW5nfGVufDB8fHx8MTc1NTg4NzM2NXww&ixlib=rb-4.1.0&q=85",
    description: "Gentle healer specializing in emotional support and inner child work."
  },
  {
    id: 4,
    name: "Ebony Goodrich",
    title: "NAVIGATOR",
    image: "https://images.unsplash.com/photo-1571112058133-056102737cd2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHxzcGlyaXR1YWwlMjBoZWFsaW5nfGVufDB8fHx8MTc1NTg4NzM2NXww&ixlib=rb-4.1.0&q=85",
    description: "Soul navigator guiding clients through their spiritual journey."
  },
  {
    id: 5,
    name: "Iman Aaliyah",
    title: "ALCHEMIST",
    image: "https://images.pexels.com/photos/3610752/pexels-photo-3610752.jpeg",
    description: "Spiritual alchemist transforming energy and consciousness."
  },
  {
    id: 6,
    name: "Gordon Allen",
    title: "REBUILDER",
    image: "https://images.unsplash.com/photo-1665680674724-3a3b3368e036?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxnb2xkZW4lMjB0cm9waHl8ZW58MHx8fHwxNzU1ODg3MzYwfDA&ixlib=rb-4.1.0&q=85",
    description: "Rebuilder of souls, specializing in life reconstruction and renewal."
  },
  {
    id: 7,
    name: "Karnada Lewis",
    title: "MATRIARCH",
    image: "https://images.unsplash.com/photo-1667205462612-09a2e51d29ee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxnb2xkZW4lMjB0cm9waHl8ZW58MHx8fHwxNzU1ODg3MzYwfDA&ixlib=rb-4.1.0&q=85",
    description: "Wise matriarch providing ancient wisdom and guidance."
  },
  {
    id: 8,
    name: "Mahalia Thomas",
    title: "MYSTIC",
    image: "https://images.pexels.com/photos/6565255/pexels-photo-6565255.jpeg",
    description: "Mystic practitioner with deep intuitive abilities."
  },
  {
    id: 9,
    name: "Micki",
    title: "TRANSMUTER",
    image: "https://images.unsplash.com/photo-1706996488299-bbb736d9a15d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxteXN0aWNhbCUyMHB1cnBsZXxlbnwwfHx8cHVycGxlfDE3NTU4ODczNTV8MA&ixlib=rb-4.1.0&q=85",
    description: "Energy transmuter specializing in vibrational healing."
  },
  {
    id: 10,
    name: "Renee Walters",
    title: "PATHFINDER",
    image: "https://images.unsplash.com/photo-1648878136576-5ac4e7d11111?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxteXN0aWNhbCUyMHB1cnBsZXxlbnwwfHx8cHVycGxlfDE3NTU4ODczNTV8MA&ixlib=rb-4.1.0&q=85",
    description: "Pathfinder helping souls discover their true calling."
  },
  {
    id: 11,
    name: "Trina",
    title: "RESTORER",
    image: "https://images.unsplash.com/photo-1636548966782-fa222f0f41f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHw0fHxteXN0aWNhbCUyMHB1cnBsZXxlbnwwfHx8cHVycGxlfDE3NTU4ODczNTV8MA&ixlib=rb-4.1.0&q=85",
    description: "Soul restorer bringing healing and renewal to wounded hearts."
  }
];

export const services = [
  {
    title: "Certified Practitioners",
    description: "Only the cream of the crop make it onto our platform."
  },
  {
    title: "Top Practitioners",
    description: "We feature the best of the best with real spiritual gifts and next-level skills."
  },
  {
    title: "Results-Oriented",
    description: "Our focus is on delivering tangible, transformative results for you."
  },
  {
    title: "Convenient Booking",
    description: "Effortlessly schedule your sessions online. All appointments are done via Zoom."
  },
  {
    title: "Diverse Services",
    description: "From astrology to holistic healing, get the guidance you deserve."
  },
  {
    title: "Quality Assurance",
    description: "We deliver nothing short of excellence."
  }
];

export const soulJourneyWeeks = [
  {
    week: 1,
    title: "The Root Reveal",
    description: "Uncover and energetically clear the core block that's been shaping your life behind the scenes. This is the root (emotional, karmic, or energetic) that everything else has built upon."
  },
  {
    week: 2,
    title: "The Pattern Dismantle", 
    description: "Release the residue of that root. Beliefs. Triggers. Survival identities. Emotional clutter. You'll begin dissolving what was never truly yours."
  },
  {
    week: 3,
    title: "Reclaim Your Power",
    description: "Reclaim your power. Recalibrate your energy field. Re-establish your inner authority and restore your frequency to reflect who you really are."
  },
  {
    week: 4,
    title: "The Soul Awakening",
    description: "Reconnect with your soul truth, gifts, and intuitive blueprint. This is where the fog lifts and your deeper knowing begins to flow."
  },
  {
    week: 5,
    title: "The Embodiment Shift",
    description: "Anchor your new energetic frequency into your day-to-day life. Start making different choices, calling in different experiences, and creating from alignment."
  },
  {
    week: 6,
    title: "The Sealing & Ascension",
    description: "Seal your energetic work, elevate your frequency, and step into your new path with clarity, certainty, and power."
  }
];

export const sessionIncludes = [
  "1:1 session over Zoom with your chosen practitioner",
  "High-level quantum energy work", 
  "Soul-guided coaching & reflection",
  "Personalized integration practices to continue the healing between sessions"
];

export const journeyExperience = [
  "Uncover and clear the core root of the block that's shaped your reality",
  "Dismantle the limiting beliefs, energetic debris, and emotional residue it created",
  "Reclaim your power, sovereignty, and inner authority",
  "Awaken your soul gifts, intuitive voice, and divine memory",
  "Integrate new energetic frequencies into your physical life",
  "Seal in your transformation and anchor your future trajectory"
];

export const images = {
  heroBackground: "https://wbhmaksvowhgyzjsvzmq.supabase.co/storage/v1/object/public/Web%20photos%20and%20graphics/trophy.png",
  wisdomLogoLocal: "/wisdom-network-logo.webp",
  wisdomMark: "/wisdom-network-mark.webp",
  trophy: "https://images.unsplash.com/photo-1504705929752-a6065ff2cd48?crop=entropy&cs=srgb&fm=jpg&q=85",
  soulJourneyHero: "https://images.unsplash.com/photo-1648878136576-5ac4e7d11111?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxteXN0aWNhbCUyMHB1cnBsZXxlbnwwfHx8cHVycGxlfDE3NTU4ODczNTV8MA&ixlib=rb-4.1.0&q=85",
  mysticalBackground: "https://images.unsplash.com/photo-1636548966782-fa222f0f41f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHw0fHxteXN0aWNhbCUyMHB1cnBsZXxlbnwwfHx8cHVycGxlfDE3NTU4ODczNTV8MA&ixlib=rb-4.1.0&q=85",
  spiritual: "https://images.unsplash.com/photo-1500904156668-758cff89dcff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxzcGlyaXR1YWwlMjBoZWFsaW5nfGVufDB8fHx8MTc1NTg4NzM2NXww&ixlib=rb-4.1.0&q=85",
  wisdomLogo: "/wisdom-network-logo.webp",
  realGuidesImage: "https://wbhmaksvowhgyzjsvzmq.supabase.co/storage/v1/object/public/Web%20photos%20and%20graphics/amp5549_authentic_guidance_spiritual_purple_and_gold_de9c576d-c21e-44b6-a030-ec6e028dcd63.png",
  bookSessionImage: "https://wbhmaksvowhgyzjsvzmq.supabase.co/storage/v1/object/public/Web%20photos%20and%20graphics/amp5549_powerful_image_of_transformation_spiritual_inspiring_de0a990b-e82c-4feb-a9d3-8c3950662c16.png",
  practitionerBanner: "https://static.wixstatic.com/media/8ea962_46724d7f224643d2b2ee93a6b3158e64~mv2.jpg/v1/fill/w_1919,h_452,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/The-Wisdom-Network-horizontal-banner.jpg",
  reviewPlaceholder: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxwb3J0cmFpdCUyMHdvbWFufGVufDB8fHx8MTc1NTg5NTgwOXww&ixlib=rb-4.1.0&q=85"
};

export const practitionersData = [
  {
    id: 1,
    name: "Gordon Allen",
    title: "Spiritual Life Coach",
    services: "Spiritual Coaching, Energy Healing, Crystal Guidance Session",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxwb3J0cmFpdCUyMG1hbnxlbnwwfHx8fDE3NTU4OTU4MDl8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    name: "Aquiera Halsey, MPH",
    title: "Worthiness Coach & Spiritual Life Coach", 
    services: "Mediumship, Psychic Readings, Spirit Guide Readings, Energy Healing, Worthiness Boost, Spiritual Coaching, Past Life Readings, Psychometry Readings, Energy Protection, Quantum Intuition Manifestation, Magnetism Activation",
    image: "https://images.unsplash.com/photo-1494790108755-2616c667feb4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxwb3J0cmFpdCUyMHdvbWFufGVufDB8fHx8MTc1NTg5NTgwOXww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    name: "GoddessIman",
    title: "Ascension Guide",
    services: "Spiritual Coaching, Manifestation Coaching, Energy Healing, Mindfulness Coaching, Energy Protection, Stress Relief",
    image: "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxwb3J0cmFpdCUyMHdvbWFufGVufDB8fHx8MTc1NTg5NTgwOXww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    name: "Bernadette Bradley",
    title: "The Universal Love & Prosperity Coach",
    services: "Spiritual Coaching, Manifestation Coaching, Psychic Readings, Mindfulness Coaching, Energy Healing, Relationship Coaching",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHxwb3J0cmFpdCUyMHdvbWFufGVufDB8fHx8MTc1NTg5NTgwOXww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 5,
    name: "Audrina Divine", 
    title: "Spiritual Life Coach",
    services: "Spiritual Coaching, Herbal Remedy Consultation, Energy Healing",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw1fHxwb3J0cmFpdCUyMHdvbWFufGVufDB8fHx8MTc1NTg5NTgwOXww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 6,
    name: "Cindie Phanhmixay",
    title: "Spiritual Life Coach",
    services: "Manifestation Coaching, Energy Healing, Mindfulness Coaching, Empowered Alignment Healing, Confidence and Self-Esteem Coaching, Magnetism Activation, Spiritual Coaching, Energy Protection, Relationship Coaching, Psychic Readings",
    image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw2fHxwb3J0cmFpdCUyMHdvbWFufGVufDB8fHx8MTc1NTg5NTgwOXww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 7,
    name: "Ebony Goodrich",
    title: "Past Life Pilot & Spiritual Life Coach", 
    services: "Past Life Regression, Spiritual Coaching, Energy Healing",
    image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw3fHxwb3J0cmFpdCUyMHdvbWFufGVufDB8fHx8MTc1NTg5NTgwOXww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 8,
    name: "Mahalia Thomas",
    title: "Spiritual Life Coach",
    services: "Spiritual Coaching, Manifestation Coaching, Psychic Readings, Mediumship, Energy Healing, Energy Protection, Quantum Intuition Manifestation, Magnetism Activation",
    image: "https://images.unsplash.com/photo-1499952127939-9bbf5af6c51c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw4fHxwb3J0cmFpdCUyMHdvbWFufGVufDB8fHx8MTc1NTg5NTgwOXww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 9,
    name: "Karnada Lewis",
    title: "Spiritual Life Coach",
    services: "Spiritual Coaching, Tarot Reading, Energy Work, Mediumship, Energy Protection",
    image: "https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw5fHxwb3J0cmFpdCUyMHdvbWFufGVufDB8fHx8MTc1NTg5NTgwOXww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 10,
    name: "Dannielle Holmes",
    title: "Confidence & Self Esteem Skin Coach",
    services: "Face Mapping Assessment, Skin Wellness Coaching, Confidence and Self-Esteem Coaching, Spiritual Coaching, Energy Healing, Relationship Coaching, Empowered Alignment Healing",
    image: "https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxMHx8cG9ydHJhaXQlMjB3b21hbnxlbnwwfHx8fDE3NTU4OTU4MDl8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 11,
    name: "Micki Mathis",
    title: "Spiritual Life Coach",
    services: "Spiritual Coaching, Energy Healing, Energy Protection, Astrology Readings",
    image: "https://images.unsplash.com/photo-1507591064344-4c6ce005b128?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxMXx8cG9ydHJhaXQlMjB3b21hbnxlbnwwfHx8fDE3NTU4OTU4MDl8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 12,
    name: "Trina Davis",
    title: "Spiritual Life Coach", 
    services: "Spiritual Coaching, Manifestation Coaching",
    image: "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxMnx8cG9ydHJhaXQlMjB3b21hbnxlbnwwfHx8fDE3NTU4OTU4MDl8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 13,
    name: "Charity Marcella Moran",
    title: "Spiritual Life Coach",
    services: "Spiritual Coaching, Energy Healing, Energy Protection, Manifestation Coaching, Mindfulness Coaching",
    image: "https://images.unsplash.com/photo-1506277886164-e25aa3f4ef7f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxM3x8cG9ydHJhaXQlMjB3b21hbnxlbnwwfHx8fDE3NTU4OTU4MDl8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 14,
    name: "Renee Walters",
    title: "Spiritual Life Coach",
    services: "Spiritual Coaching, Energy Healing, Energy Protection",
    image: "https://images.unsplash.com/photo-1601233749202-95d04d5b3c00?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxNHx8cG9ydHJhaXQlMjB3b21hbnxlbnwwfHx8fDE3NTU4OTU4MDl8MA&ixlib=rb-4.1.0&q=85"
  }
];

export const serviceCategories = [
  "All", "Specializes in Female clients", "Specializes in LGBTQ+ clients", "Specializes in Male clients",
  "Astrology Readings", "Confidence and Self-Esteem Coaching", "Crystal Guidance Session", 
  "Empowered Alignment Healing", "Energy Healing", "Energy Protection", "Face Mapping Assessment",
  "Herbal Remedy Consultation", "Joint Manifestation Coaching", "Magnetism Activation",
  "Manifestation Coaching", "Mediumship", "Mindfulness Coaching", "Past Life Readings",
  "Past Life Regression", "Psychic Readings", "Psychometry Readings", "Quantum Intuition Manifestation",
  "Relationship Coaching", "Skin Wellness Coaching", "Spirit Guide Readings", "Spiritual Life Coaching",
  "Stress Relief", "Tarot Reading", "Worthiness Boost"
];

export const socialLinks = [
  { name: "Instagram", url: "https://www.instagram.com/thewisdomnetwork/", icon: "Instagram" },
  { name: "Facebook", url: "https://www.facebook.com/people/The-Wisdom-Network/61575635817874/", icon: "Facebook" },
  { name: "LinkedIn", url: "https://www.linkedin.com/company/the-wisdom-network?trk=public_post_feed-actor-name", icon: "Linkedin" },
  { name: "YouTube", url: "https://www.youtube.com/@TheWisdomNetwork1111", icon: "Youtube" },
  { name: "Threads", url: "https://www.threads.com/@thewisdomnetwork", icon: "AtSign" }
];

// Detailed practitioner data for individual pages
export const practitionersDetailData = [
  {
    id: "dannielle-holmes",
    name: "Dannielle Holmes",
    title: "Confidence & Self Esteem Skin Coach",
    image: "https://static.wixstatic.com/media/8ea962_6ef6bd36e610433c866af3e9e2e59112~mv2.jpg/v1/fill/w_663,h_699,fp_0.30_0.47,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Dannielle%20Holmes%20Headshot.jpg",
    about: "Empowering women to look and feel their best! I am a Skin Artisan and I specialize in Handmade All Natural Organic Skin Care. I excel in restoring confidence and self esteem in my clients with my products as well as providing solutions to genuine inner happiness. I love to help people with their problems and I love to watch them blossom and grow into their new and improved selves!",
    qualifications: "Certified Life Coach",
    services: "Face Mapping Assessment, Skin Wellness Coaching, Confidence and Self-Esteem Coaching, Spiritual Coaching, Energy Healing, Relationship Coaching, Empowered Alignment Healing",
    specializes: "Female Clients",
    bookingLinks: {
      consultation: "https://thewisdomnetwork.as.me/?calendarID=10569981",
      session: "https://thewisdomnetwork.as.me/?calendarID=10569981",
      ongoing: "https://app.acuityscheduling.com/catalog.php?owner=32632119&category=Spiritual+Coaching+Packages"
    },
    hasMoreReviews: true,
    reviews: [
      {
        name: "K. Green",
        text: "I'm so very grateful to have met Dannielle. Since meeting and communicating with her, I've grown familiar to change, adjusting and pivoting behaviors that could have truly altered my reality, and most importantly that I have a choice and there's power in decisions. With many many reminders to listen and have patience, and to know giving up is never an option. I can say so much more, but I thank her for the guidance in spaces I didn't even realize I needed.",
        image: "https://images.unsplash.com/photo-1494790108755-2616c667feb4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxwb3J0cmFpdCUyMHdvbWFufGVufDB8fHx8MTc1NTg5NTgwOXww&ixlib=rb-4.1.0&q=85"
      },
      {
        name: "Que H.",
        text: "A few years ago after having foot surgery, I began to see hyperpigmentation on my skin. I consulted dannielle of blue lotus essentials as a last ditch effort because no other products had worked. She recommended I utilize the 4B cream and apply on a daily basis. After a few months I noticed the dark spots grew lighter and eventually went away completely. Not only do I appreciate Dannielle's guidance on how to treat my skin. She provided guidance on how I should focus on gut health too. Now I proudly show off my even and supple skin.",
        image: "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxwb3J0cmFpdCUyMHdvbWFufGVufDB8fHx8MTc1NTg5NTgwOXww&ixlib=rb-4.1.0&q=85"
      },
      {
        name: "A. Thompson",
        text: "My name is AlexanderiaMonet and here are my reviews from working with Dannielle the Spiritual Consultant Confidence Dannielle helped me tremendously with my confidence and what I mean is that she encouraged me to do things that brought me joy and happiness which in turn brought me peace and being ok with doing things that made me feel good. She also helped me by giving the tools I needed to stand up for myself and speak up for myself because I didn't see myself as valuable as I should have and truly helped me to develop those skills and tools that had lead me to be the kind of person I've always wanted to be, a women who allows herself leisure time because she values herself hence she's busy and when she needs rest as well as someone who holds true to her standards and boundaries! These things have helped me transform into very successful confident women. Relationship Dannielle helped me to find myself when I lost myself in my relationship, I literally was giving everything all the time and when things got bad she helped by doing magic on my heart with air magic and literally helped me to see myself again as person of value and worthy of love. She helped me end the relationship completely and handle things on my terms only with loads of air magic again! I love when she uses air magic for me it always encourages and empowers me deeply Business She literally created the layout and structure for my restaurant and not even a year later I was fully into doing mx business full time and experienced a full year of consistent success. Dannielle is the best and I'll always believe in her works Skin Issues Her skin care line is phenomenal I've been using it for 5/6 years now and I've been recommending it to everyone and I've even purchased orders for others so that can expertzhr magic that is her healing products! My face healed completely from chemotherapy and when I'd get cold sores from all the meds from my doctors her 4 B magic cream one week of consistent use and it was gone! She has magic on every level and it's mind blowing how quick I get rest.",
        image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHxwb3J0cmFpdCUyMHdvbWFufGVufDB8fHx8MTc1NTg5NTgwOXww&ixlib=rb-4.1.0&q=85"
      },
      {
        name: "R. W.",
        text: "I had healing work done by Dannielle. I had lower back and hip pain on my right side. I explained my problem to Dannielle and also that I needed a chiropractic adjustment. Usually, if I stretch everyday, I dont have problems, but it had been a while. Dannielle did her magic! Within 60 seconds, the pain was reduced 60%. I could feel the energy moving from my lower back to my hip, and I felt pressure. But, within 10-15 minutes afterward, I was completely pain-free. It felt great to be relieved of pain, and I didn't have to take a pain pill. And this done remotely. What an amazing experience. Dannielle is awesome!",
        image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxwb3J0cmFpdCUyMG1hbnxlbnwwfHx8fDE3NTU4OTU4MDl8MA&ixlib=rb-4.1.0&q=85"
      }
    ]
  },
  {
    id: "trina-davis",
    name: "Trina Davis",
    title: "Spiritual Life Coach",
    image: "https://static.wixstatic.com/media/8ea962_3501a71ab7eb4f5abbc7b8529f6006ef~mv2.png/v1/fill/w_282,h_284,fp_0.50_0.46,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Trina%20Headshot.png",
    about: "Dedicated spiritual life coach helping individuals discover their authentic path and inner wisdom. With years of experience in spiritual coaching and manifestation work, I guide clients through transformative journeys of self-discovery and empowerment.",
    qualifications: "Certified Spiritual Life Coach, Manifestation Coach",
    services: "Spiritual Coaching, Manifestation Coaching",
    bookingLinks: {
      consultation: "https://thewisdomnetwork.as.me/",
      session: "https://thewisdomnetwork.as.me/",
      ongoing: null
    },
    hasMoreReviews: false,
    reviews: [
      {
        name: "M. Johnson",
        text: "Trina has been instrumental in my spiritual growth journey. Her guidance has helped me manifest my dreams and connect with my higher purpose.",
        image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxwb3J0cmFpdCUyMHdvbWFufGVufDB8fHx8MTc1NTg5NTgwOXww&ixlib=rb-4.1.0&q=85"
      }
    ]
  },
  {
    id: "goddessiman",
    name: "GoddessIman",
    title: "Ascension Guide",
    image: "https://static.wixstatic.com/media/8ea962_e39ffe1b3a994739b09622c1923cf98e~mv2.jpg/v1/fill/w_282,h_284,fp_0.50_0.46,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Iman%20Aaliyah.jpg",
    about: "As an Ascension Guide, I help souls navigate their spiritual awakening and ascension journey. I specialize in energy healing, manifestation coaching, and providing guidance for those ready to step into their divine power and purpose.",
    qualifications: "Certified Ascension Guide, Energy Healer",
    services: "Spiritual Coaching, Manifestation Coaching, Energy Healing, Mindfulness Coaching, Energy Protection, Stress Relief",
    bookingLinks: {
      consultation: "https://thewisdomnetwork.as.me/",
      session: "https://thewisdomnetwork.as.me/",
      ongoing: null
    },
    hasMoreReviews: false,
    reviews: [
      {
        name: "S. Williams",
        text: "GoddessIman's energy healing sessions have been life-changing. She has helped me release old patterns and step into my power with confidence.",
        image: "https://images.unsplash.com/photo-1494790108755-2616c667feb4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxwb3J0cmFpdCUyMHdvbWFufGVufDB8fHx8MTc1NTg5NTgwOXww&ixlib=rb-4.1.0&q=85"
      }
    ]
  }
  // Additional practitioners can be added here following the same structure
];